// Tiny AngularJS module to keep track of jQuery dependencies
/* global jQuery: false */

angular.module('jQuery', [])
.factory('jQuery', function() {
    return jQuery;
});
